import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import { FETCH_BETTING_ODDS_DATA, setBettingOddsData } from '../actions';

/**
 * @typedef {object} FetchBettingOddsDataAction
 * @property {object} payload
 * @property {string} [payload.seasonPid]
 */

/**
 * @param {FetchBettingOddsDataAction} action - The Redux action.
 */
export function* fetchBettingOddsData(action) {
    const { seasonPid } = action.payload;

    // yield put(setBettingOddsDataRequest(action.payload));

    let data = {};

    if (seasonPid) {
        data = yield call(
            fetchWithMisToken,
            `${PULSE.app.environment.cfsApi}/wagering/playerMarket/brownlow`
        );

        if (data) {
            yield put(setBettingOddsData({ ...data }));
        }
    }

    // yield put(removeLeaderboardDataRequest(action.payload));

    yield put(FETCH_BETTING_ODDS_DATA.success(data));
}
